// extracted by mini-css-extract-plugin
module.exports = {"textCenter":"Col_textCenter__5fyKP","textLeft":"Col_textLeft__q2bqr","textRight":"Col_textRight__IdGzi"};